import { ScenarioRowItem } from "./scenario-row-item";
import type { OutlineListItem } from "./scenarios-tab-types";

interface ScenarioGroupProps {
  title: string;
  count: number;
  scenarios: OutlineListItem[];
  projectId: string;
}

export function ScenarioGroup({
  title,
  count,
  scenarios,
  projectId,
}: ScenarioGroupProps) {
  return (
    <section className="space-y-2">
      {title && (
        <div className="flex items-baseline justify-between px-1">
          <h2 className="text-sm font-semibold text-foreground">{title}</h2>
          <span className="text-xs tabular-nums text-muted-foreground">
            {count} {count === 1 ? "scenario" : "scenarios"}
          </span>
        </div>
      )}
      <div className="rounded-lg border border-border bg-card overflow-hidden">
        <ol className="divide-y divide-border/60">
          {scenarios.map((o) => (
            <ScenarioRowItem
              key={o.id}
              scenario={o}
              projectId={projectId}
              headingLevel={title ? "h3" : "h2"}
            />
          ))}
        </ol>
      </div>
    </section>
  );
}
